import { 
  collection, 
  addDoc, 
  getDocs, 
  doc, 
  updateDoc, 
  deleteDoc, 
  orderBy, 
  query,
  onSnapshot 
} from 'firebase/firestore';
import { db } from './config';

const COLLECTION_NAME = 'notices';

// 공지사항 컬렉션 참조
const noticesRef = collection(db, COLLECTION_NAME);

// 모든 공지사항 가져오기
export const getNotices = async () => {
  try {
    const q = query(noticesRef, orderBy('createdAt', 'desc'));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('공지사항을 가져오는데 실패했습니다:', error);
    throw error;
  }
};

// 실시간 공지사항 구독
export const subscribeToNotices = (callback) => {
  const q = query(noticesRef, orderBy('createdAt', 'desc'));
  return onSnapshot(q, (snapshot) => {
    const notices = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    callback(notices);
  });
};

// 새 공지사항 추가
export const addNotice = async (noticeData) => {
  try {
    const docRef = await addDoc(noticesRef, {
      ...noticeData,
      createdAt: new Date(),
      updatedAt: new Date()
    });
    return docRef.id;
  } catch (error) {
    console.error('공지사항 추가 실패:', error);
    throw error;
  }
};

// 공지사항 수정
export const updateNotice = async (noticeId, updateData) => {
  try {
    const noticeDoc = doc(db, COLLECTION_NAME, noticeId);
    await updateDoc(noticeDoc, {
      ...updateData,
      updatedAt: new Date()
    });
  } catch (error) {
    console.error('공지사항 수정 실패:', error);
    throw error;
  }
};

// 공지사항 삭제
export const deleteNotice = async (noticeId) => {
  try {
    const noticeDoc = doc(db, COLLECTION_NAME, noticeId);
    await deleteDoc(noticeDoc);
  } catch (error) {
    console.error('공지사항 삭제 실패:', error);
    throw error;
  }
}; 